const transitionProperty = {
  name: "transition-property",
  path: "/transition-property",
  title: "transition-property",
  description: "Utilities for controlling which properties transition.",
  value: {
    'transition-property': {
      'transition-none': 'none',
      'transition-all': 'all',
      'transition-color': 'color',
      'transition-opacity': 'opacity',
      'transition-font-size': 'font-size',
      'transition-box-shadow': 'box-shadow',
      'transition-transform': 'transform',
      'transition-<property>': '<property>',
    },
  },
  exampleData: [
    {
      example: {
        code: `<button class="transition-none bg-color-blue-500 hover:bg-color-blue-700 text-color-white font-bold py-2 px-4 rounded">
  No Transition
</button>`
      }
    },
    {
      example: {
        code: `<button class="transition-all duration-300 bg-color-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
  All Transition
</button>` 
      }
    },
    {
      example: {
        code: `<button class="transition-color duration-300 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
  Color Transition
</button>`
      }
    },
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">transition-none</code> to remove all transitions from an element.
      </p>
      <div>
        <button class="transition-none bg-color-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          No Transition
        </button>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">transition-all</code> to apply transitions to all changed properties.
      </p>
      <div>
        <button class="transition-all duration-300 bg-color-blue-500 hover:-translate-y-1 hover:scale-110 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          All Transition
        </button>
      </div>
      `
    },
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">transition-color</code> to apply transitions to color properties.
      </p>
      <div>
        <button class="transition-color duration-300 bg-color-blue-500 hover:bg-color-indigo-500 text-color-white font-bold py-2 px-4 rounded">
          Color Transition
        </button>
      </div>
      `
    },
  ]
};

export default transitionProperty;
<div className="transition-all duration-300 transition-color hover:-translate-y-1 hover:scale-110 hover:bg-color-indigo-500"></div>